import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../componentLibrary/Button';

export const Undo = ({ isDisabled, onClick }) => (
    <Button
        type="simple"
        width={30}
        label="Undo"
        icon="undo-alt"
        hasTooltip={false}
        iconSize={15}
        marginBottom={0}
        padding="5px 0px 0px 0px"
        disabled={isDisabled}
        color={isDisabled ? '#CCCCCC' : '#424242'}
        onClick={onClick}
        backgroundColor="#fcfcfc"
    />
);

Undo.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export const Redo = ({ isDisabled, onClick }) => (
    <Button
        type="simple"
        width={30}
        label="Redo"
        hasTooltip={false}
        icon="redo-alt"
        iconSize={15}
        marginBottom={0}
        padding="5px 0px 0px 0px"
        disabled={isDisabled}
        color={isDisabled ? '#CCCCCC' : '#424242'}
        onClick={onClick}
        backgroundColor="#fcfcfc"
    />
);

Redo.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
